import { DataRequest, LegacyDataRequest } from '@standardkit/core';

export function mapLegacyDataRequest<T>(legacyRequest: LegacyDataRequest<T>): DataRequest<T> {
  return {
    offset: legacyRequest.pagination.offset,
    limit: legacyRequest.pagination.limit,
    // TODO : Implement
  };
}
